import type { UseQueryResult } from '@tanstack/react-query'
import type { PaginationProps } from '../common/Pagination'

type Query = UseQueryResult<{ page: { totalPages: number } }>

export const mapQueryToPaginationProps = (
  query: Query,
  currentPage: number,
  setCurrentPage: (currentPage: number) => void,
): PaginationProps | undefined => {
  if (!query.isSuccess) return

  const { page } = query.data

  if (!(page.totalPages > 1)) return

  return {
    currentPage,
    pageCount: page.totalPages,
    onChange: setCurrentPage,
  }
}
